/** Motion tokens — duration, easing, delay, and stagger */
export const duration = {
  instant: 0,
  fast: 150,
  normal: 250,
  slow: 400,
  slower: 600,
} as const;

export const easing = {
  standard: "cubic-bezier(0.4, 0, 0.2, 1)",
  decelerate: "cubic-bezier(0, 0, 0.2, 1)",
  accelerate: "cubic-bezier(0.4, 0, 1, 1)",
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
  linear: "linear",
} as const;

export const delay = {
  none: 0,
  short: 50,
  medium: 100,
  long: 200,
} as const;

export const stagger = {
  tight: 30,
  normal: 50,
  relaxed: 80,
} as const;

export type TDuration = typeof duration;
export type TEasing = typeof easing;
export type TDelay = typeof delay;
export type TStagger = typeof stagger;
